import React from 'react';
import styled, { keyframes } from 'styled-components';

import { theme } from '../../theme';
import { IPropRing, IProps, IRingPartProps } from './loader.types';

const rotation = keyframes`
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
`;

const Ring = styled.div`
	display: inline-block;
	position: relative;
	${({ size }: IPropRing) => `
	width: ${size};
	height: ${size};`}
`;

const RingPart = styled.div`
	box-sizing: border-box;
	display: block;
	position: absolute;
	border: 2px solid #fff;
	${({ size, colorVariant }: IRingPartProps) => `
	width: ${size};
	height: ${size};
	border-color: ${theme.colors.text[colorVariant]} transparent transparent transparent;
`};

	border-radius: 50%;
	animation: ${rotation} 1.2s cubic-bezier(0.5, 0, 0.5, 1) infinite;

	:nth-child(1) {
		animation-delay: -0.45s;
	}
	:nth-child(2) {
		animation-delay: -0.3s;
	}
	:nth-child(3) {
		animation-delay: -0.15s;
	}
`;

export const Loader: React.FunctionComponent<IProps> = ({ size, colorVariant }: IProps) => {
	return (
		<Ring size={size}>
			<RingPart size={size} colorVariant={colorVariant} />
			<RingPart size={size} colorVariant={colorVariant} />
			<RingPart size={size} colorVariant={colorVariant} />
		</Ring>
	);
};
